import { type ISmartCallFlowStep } from 'entities/SmartCall/api/types'

export const getSmartActionNextIdsFromStep = (step: ISmartCallFlowStep): string[] => {
  if (
    step.id === 'callingFlow' &&
    step.args?.next_on_answered !== undefined &&
    step.args?.next_on_no_answer !== undefined
  ) {
    return [step.args.next_on_answered, step.args.next_on_no_answer]
  }
  if (
    step.id === 'forwardCallMulti' &&
    step.args?.next_on_transferred !== undefined &&
    step.args?.next_on_no_transferred !== undefined
  ) {
    return [step.args.next_on_transferred, step.args.next_on_no_transferred]
  }
  if (
    step.id === 'businessHours' &&
    step.args?.next_on_during_hours !== undefined &&
    step.args?.next_on_after_hours !== undefined
  ) {
    return [step.args.next_on_during_hours, step.args.next_on_after_hours]
  }
  if (step.id === 'ivrPhoneTree') {
    return step.args?.menu_options?.map((item) => item.stepId)
  }

  if (!step.next) {
    return []
  }

  return [step.next]
}
